// extracted by mini-css-extract-plugin
module.exports = {"grid":"bh_bK","logoContainer":"bh_fT"};